import {element_exists} from "../functions";

export var fnInitTranslationsManager = function () {
    if (!element_exists('#translation-manager')) {
        return false;
    }
    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('[name="_token"]').val()}});

    $('.delete-key').html('<div class="icon" data-icon="fa-trash"><i class="fa fa-trash"></i><span class="icon-class"></span></div>');

    $('.editable').editable().on('hidden', function (e, reason) {

        var locale = $(this).data('locale');
        if (reason === 'save') {
            $(this).removeClass('status-0').addClass('status-1');
        }
        if (reason === 'save' || reason === 'nochange') {
            var $next = $(this).closest('tr').next().find('.editable.locale-' + locale);

            setTimeout(function () {
                $next.editable('show');
            }, 300);
        }
    });

    $('.group-select').on('change', function () {
        console.log('here');
        var group = $(this).val();
        var url = '';
        if (group) {

            url = '/translations/' + $(this).val();

        } else {
            url = '/translations/view';
        }

        $.pjax({
            url: url,
            container: '#pjax-container',
        });

    });

    $("a.delete-key").on('click', function (event) {
        event.preventDefault();
        var row = $(this).closest('tr');
        var url = $(this).attr('href');
        var id = row.attr('id');

        var lang = allLangFiles.translations.js;

        $.confirm({
            title: lang.delete_title + id + '?',
            content: lang.delete_content + id + '?',
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.post(url, {id: id}, function () {
                            row.remove();
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                },
            }
        });
    });

    $('.form-import').on('ajax:success', function (e, data) {
        $('div.success-import strong.counter').text(data.counter);
        $('div.success-import').slideDown();
    });

    $('.form-find').on('ajax:success', function (e, data) {
        $('div.success-find strong.counter').text(data.counter);
        $('div.success-find').slideDown();
    });

    $('.form-publish').on('ajax:success', function (e, data) {
        $('div.success-publish').slideDown();
    });
};